import {
  STEP_DEPARTING_FLIGHT,
  STEP_RETURNING_FLIGHT,
  STEP_MONTH_CALENDAR,
  STEP_DAY_CALENDAR,
  STEP_CAPACITY,
  STEP_CHANGE_DATES,
  STEP_CHANGE_PACKAGE,
  STEP_TOUR_DATES,
  STEP_EXPERIENCES,
  STEP_PAYMENT,
  STEP_BALANCE_PAYMENT,
  STEP_INSTALMENT_PAYMENT,
  STEP_INSTALMENT_BALANCE_PAYMENT,
  STEP_RESERVE_FOR_ZERO_PAYMENT,
} from 'constants/booking'
import {
  CUDO_TRAVEL,
  DEALS_TRAVEL,
  LUXURY_ESCAPES,
  SCOOPON_TRAVEL,
  TREATME_TRAVEL,
} from 'constants/brands'

export const CHECKOUT_HEADER_PATHS = [
  `/:regionCode/booking/${STEP_DEPARTING_FLIGHT}`,
  `/:regionCode/booking/${STEP_RETURNING_FLIGHT}`,
  `/:regionCode/booking/${STEP_MONTH_CALENDAR}`,
  `/:regionCode/booking/${STEP_DAY_CALENDAR}`,
  `/:regionCode/booking/${STEP_CAPACITY}`,
  `/:regionCode/booking/${STEP_CHANGE_DATES}`,
  `/:regionCode/booking/${STEP_CHANGE_PACKAGE}`,
  `/:regionCode/booking/${STEP_TOUR_DATES}`,
  `/:regionCode/booking/${STEP_EXPERIENCES}`,
  `/:regionCode/booking/${STEP_PAYMENT}`,
  `/:regionCode/booking/${STEP_BALANCE_PAYMENT}`,
  `/:regionCode/booking/${STEP_INSTALMENT_PAYMENT}`,
  `/:regionCode/booking/${STEP_INSTALMENT_BALANCE_PAYMENT}`,
  `/:regionCode/booking/${STEP_RESERVE_FOR_ZERO_PAYMENT}`,
  `/:regionCode/bb/booking/${STEP_PAYMENT}`,
  '/:regionCode/checkout/:cartId/:step',
  '/:regionCode/checkout/:step',
  '/:regionCode/checkout',
  '/:regionCode/checkout-restore-cart',
  '/:regionCode/checkout-gateway',
  '/:regionCode/travel-protection/quote',
  '/:regionCode/travel-protection/checkout',
  '/:regionCode/gift-cards/checkout',
  '/:regionCode/travel-protection/details',
  '/:regionCode/travel-protection/payment',
  '/:regionCode/pay/:paymentLinkId',
]

export const MULTI_CLICK_UNSUB_SUPPORTED_BRANDS = [
  LUXURY_ESCAPES,
  CUDO_TRAVEL,
  SCOOPON_TRAVEL,
  DEALS_TRAVEL,
  TREATME_TRAVEL,
]
